import { render } from "./PictorialsView.vue?vue&type=template&id=90007bdc&scoped=true"
const script = {}

import "./PictorialsView.vue?vue&type=style&index=0&id=90007bdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90007bdc"]])

export default __exports__